const formatoMoeda = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
})

const formatoData = new Intl.DateTimeFormat('pt-BR', {
  timeZone: 'America/Sao_Paulo',
})

export function formatarMoeda(valor: number): string {
  return formatoMoeda.format(valor)
}

export function formatarData(data: Date): string {
  return formatoData.format(data)
}
